<template lang="pug">
div#init_tags
</template>
<script>
import Vue from 'vue'
export default {
  props: {
    tag_names: {type: Array, default: ""},
  },
  async mounted(){
    await Vue.nextTick()
    this.$store.commit("tag/setItems", this.tag_names)
  },
}
</script>
